/*
 * @Description: 
 * @Version: 2.0
 * @Autor: chenkang
 * @Date: 2021-09-01 17:46:54
 * @LastEditors: qiuwenjing qiuwenjing@vip56.cn
 * @LastEditTime: 2024-06-17 10:09:42
 */
import { Post, Get, Patch, Put, Delete, Download, ax } from './http_pad';
import { type } from './interface';
import qs from 'qs';
export namespace TbTransferOrder {
    /**
     * 获取调拨单列表V2
     */
    export var GetTbTransferOrderListV2 = (body: any): Promise<any> => {
        return Get(`/api/TbTransferOrder/GetTbTransferOrderListV2`, body);
    };
    /**
    * 新增调拨单V2
    */
   export var PostTransferOrderV2 = (body: any): Promise<any> => {
       return Post(`/api/TbTransferOrder/PostTransferOrderV2`, body);
   };
   /**
    * 接收调拨V2
    */
   export var PutTransferOrderStatusV2 = (body: any): Promise<any> => {
       return Put(`/api/TbTransferOrder/PutTransferOrderStatusV2`, body);
   };
   /**
     * 获取调拨单详情V2
     */
    export var GetTbTransferOrderByIdV2 = (id): Promise<any> => {
        return Get(`/api/TbTransferOrder/GetTbTransferOrderByIdV2?id=${id}`, {});
    };
    /**
     * 
    检查接收店铺是否存在相同货号商品-每次接收调拨前调用
     */
     export var CheckTransferGoods = (id): Promise<any> => {
        return Get(`/api/TbTransferOrder/CheckTransferGoods?id=${id}`, {});
    };
}



// WEBPACK FOOTER //
// ./src/http/api_TbTransferOrder.ts